'use strict';

import React, { Fragment } from 'react';
import bemit from 'Functions/bemit';
import { isTrue, getOpenInfos } from 'Shared/utilities';
import { days_config } from 'Shared/options';
const {
  app,
  moment
} = window;
export default function CoworkingPrices(props) {
  const col_class = 'c-coworking-space__price__row__col';
  moment.locale('fr');
  const dates = (props.dates || []).map(function (date) {
    let modifiers = ['date'];
    const is__sunday = moment(date).isoWeekday() === 7;
    if (is__sunday) modifiers.push('weekend');
    let output = /*#__PURE__*/React.createElement("div", {
      key: date,
      className: bemit(col_class, modifiers)
    }, /*#__PURE__*/React.createElement("span", null, moment(date).format('ddd'), ' ', moment(date).format('DD')), /*#__PURE__*/React.createElement("span", null, moment(date).format('MMM')));
    return output;
  });
  let coworking_spaces = (props.spaces || []).map(function (coworking_space) {
    const availabilities = coworking_space.availabilities || {};
    const schedule = coworking_space.schedule || {};
    let coworking_cols = [];
    let disposition_day_price_cols, disposition_half_day_price_cols;
    if (coworking_space.type === 'a_calm_coworking_space') {
      coworking_cols = (props.dates || []).map(function (date) {
        const en_day_name = days_config[moment(date).isoWeekday() - 1];
        const availability = availabilities[date] || {};
        let col_modifiers = [];
        const is__sunday = moment(date).isoWeekday() === 7;
        if (is__sunday) col_modifiers.push('weekend');
        let modifiers = [];
        if (availability === 'close') {
          modifiers.push('closed');
          modifiers.push('manual');
        }
        const [is__open, is__custom] = getOpenInfos({
          schedule: schedule,
          availability: availabilities,
          type: coworking_space.type,
          date: date
        });
        const cols = ['one_three', 'four_seven', 'height_more'].map(function (range_name) {
          let output;
          if (!is__open) {
            output = /*#__PURE__*/React.createElement("div", {
              key: date + '-' + range_name,
              className: bemit(col_class, col_modifiers)
            }, /*#__PURE__*/React.createElement("span", {
              className: bemit('c-open-date', modifiers)
            }, "Ferm\xE9"));
            return output;
          }
          const custom_price = coworking_space.pricings?.[range_name]?.[date]?.price;
          output = /*#__PURE__*/React.createElement("div", {
            key: date + '-' + range_name,
            className: bemit(col_class, col_modifiers)
          }, custom_price || custom_price === 0 ? /*#__PURE__*/React.createElement("span", {
            className: bemit('c-open-date', ['manual', 'open'])
          }, custom_price, "\xA0\u20AC") : (coworking_space.schedule_price?.[range_name].price || '') + ' €');
          return output;
        });
        return cols;
      });
    } else {
      let morning_close_days = Object.keys(schedule).filter(function (day) {
        const morning_closed = !isTrue(schedule[day].morning);
        return morning_closed;
      });
      let afternoon_close_days = Object.keys(schedule).filter(function (day) {
        const afternoon_closed = !isTrue(schedule[day].afternoon);
        return afternoon_closed;
      });
      disposition_day_price_cols = (props.dates || []).map(function (date) {
        let output;
        const en_day_name = days_config[moment(date).isoWeekday() - 1];
        const availability = availabilities[date] || {};
        let is__morning_closed = availability?.morning === 'close' || morning_close_days.includes(en_day_name) && availability?.morning !== 'open';
        let is__afternoon_closed = availability?.afternoon === 'close' || afternoon_close_days.includes(en_day_name) && availability?.afternoon !== 'open';
        let col_modifiers = [],
          modifiers = [];
        const is__sunday = moment(date).isoWeekday() === 7;
        if (is__sunday) col_modifiers.push('weekend');
        if (is__morning_closed || is__afternoon_closed) {
          if (availability?.morning === 'close' || availability?.afternoon === 'close') {
            modifiers.push('closed');
            modifiers.push('manual');
          }
          output = /*#__PURE__*/React.createElement("div", {
            key: date,
            className: bemit(col_class, col_modifiers)
          }, /*#__PURE__*/React.createElement("span", {
            className: bemit('c-open-date', modifiers)
          }, is__afternoon_closed && is__morning_closed ? 'Fermé' : is__afternoon_closed ? 'Fermé l\'après-midi' : 'Fermé le matin'));
          return output;
        }
        const custom_price = coworking_space.pricings?.disposition_seat?.price_day?.[date];
        const is__free = coworking_space.type === 'c_open_coworking_space';
        output = /*#__PURE__*/React.createElement("div", {
          key: date,
          className: bemit(col_class, col_modifiers)
        }, is__free ? /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date', ['open'])
        }, "Ouvert") : custom_price || custom_price === 0 ? /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date', ['manual', 'open'])
        }, custom_price, "\xA0\u20AC") : /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date')
        }, coworking_space?.disposition_seat?.price_day, "\xA0\u20AC"));
        return output;
      });
      disposition_half_day_price_cols = (props.dates || []).map(function (date) {
        let output;
        const en_day_name = days_config[moment(date).isoWeekday() - 1];
        const availability = availabilities[date] || {};
        let is__morning_closed = availability?.morning === 'close' || morning_close_days.includes(en_day_name) && availability?.morning !== 'open';
        let is__afternoon_closed = availability?.afternoon === 'close' || afternoon_close_days.includes(en_day_name) && availability?.afternoon !== 'open';
        let col_modifiers = [],
          modifiers = [];
        const is__sunday = moment(date).isoWeekday() === 7;
        if (is__sunday) col_modifiers.push('weekend');
        if (availability?.morning === 'close' && availability?.afternoon === 'close') {
          modifiers.push('closed');
          modifiers.push('manual');
        }
        if (is__afternoon_closed && is__morning_closed) {
          output = /*#__PURE__*/React.createElement("div", {
            key: date,
            className: bemit(col_class, col_modifiers)
          }, /*#__PURE__*/React.createElement("span", {
            className: bemit('c-open-date', modifiers)
          }, "Ferm\xE9"));
          return output;
        }
        const custom_price = coworking_space.pricings?.disposition_seat?.price_half_day?.[date];
        const is__free = coworking_space.type === 'c_open_coworking_space';
        output = /*#__PURE__*/React.createElement("div", {
          key: date,
          className: bemit(col_class, col_modifiers)
        }, is__free ? /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date', ['open'])
        }, "Ouvert") : custom_price || custom_price === 0 ? /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date', ['manual', 'open'])
        }, custom_price, "\xA0\u20AC") : /*#__PURE__*/React.createElement("span", {
          className: bemit('c-open-date')
        }, coworking_space?.disposition_seat?.price_half_day, "\xA0\u20AC"));
        return output;
      });
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space c-coworking-space--row",
      key: coworking_space.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__name"
    }, coworking_space.name), /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price"
    }, coworking_space.type === 'a_calm_coworking_space' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, ['title'])
    }, "De 1 \xE0 3h"), coworking_cols.map(cols => cols[0])), /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, ['title'])
    }, "De 4 \xE0 7h"), coworking_cols.map(cols => cols[1])), /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, ['title'])
    }, "8h et +"), coworking_cols.map(cols => cols[2]))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, ['title'])
    }, "Demi-journ\xE9e"), disposition_half_day_price_cols), /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, ['title'])
    }, "Journ\xE9e"), disposition_day_price_cols))));
    return output;
  });
  const output = /*#__PURE__*/React.createElement("div", {
    className: "c-coworking-space-prices"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-coworking-space c-coworking-space--date"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-coworking-space__name c-coworking-space__name--date"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-coworking-space__price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-coworking-space__price__row\r c-coworking-space__price__row--date"
  }, /*#__PURE__*/React.createElement("div", {
    className: bemit(col_class, ['title'])
  }), dates))), coworking_spaces);
  return output;
}
